import { Component, signal } from '@angular/core'
import { LoadingSpinnerService } from './loading-spinner.service'
import { SpinnerComponent } from './spinner.component'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

@Component({
  selector: 'app-global-spinner',
  imports: [SpinnerComponent],
  template: `
    <div class="spinner-anchor">
      @if (active()) {
        <div class="spinner-container" id="overlay">
          <app-spinner/>
        </div>
      }
    </div>
  `,
  styles: `
    .spinner-anchor {
      position: relative;
      width: 0;
      height: 0;
    }

    .spinner-container {
      margin: 0;
      position: fixed;
      display: flex;
      justify-content: center;
      vertical-align: middle;
      align-items: center;
      top: 0;
      left: 0;
      z-index: 200001;
      background-color: rgba(128, 128, 128, 0.5);
      width: 100vw;
      height: 100vh;
    }
  `,
})
export class GlobalSpinnerComponent {
  protected readonly active = signal(true)

  constructor(loadingSpinnerService: LoadingSpinnerService) {
    loadingSpinnerService.showSpinner.pipe(takeUntilDestroyed()).subscribe(active => {
      this.active.set(active)
    })
  }
}
